<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li :class="{ active: tabIndex === 0 }" @click="clickTab(0)">
          积分统计
        </li>
        <li :class="{ active: tabIndex === 1 }" @click="clickTab(1)">
          积分明细
        </li>
      </ul>
    </div>
    <div class="member-main-body">
      <div class="integral-total" v-show="tabIndex == 0">
        <div class="icon">
          <!-- sultan -->
          <!-- <img src="../../assets/images/v3/integral-01.png" /> -->
           <span class="iconfont iconselect"></span>
        </div>
        <div class="integral">
          <span>我的积分：</span>
          <span class="color0">{{ integralStatistics.Integration }}</span>
        </div>
        <div class="sign">
          <template v-if="integralStatistics.IsCheckInfTask">
            <Button
              v-if="integralStatistics.isSignIn == 1"
              type="default"
              shape="circle"
              disabled
              style="width: 100px"
              >已签到</Button
            >
            <Button
              v-else
              type="primary"
              style="width: 100px"
              shape="circle"
              @click="signIn"
              >每日签到</Button
            >
          </template>
          <div
            class="tips"
            v-if="integralStatistics.IsIntegration"
            style="cursor: pointer"
          >
            <Poptip
              title="积分规则"
              word-wrap
              width="500"
              :content="integralStatistics.IntegralContent"
              placement="bottom-end"
            >
              <Icon type="ios-help-circle-outline" size="18" />
              <span style="margin-left: 3px">积分规则</span>
            </Poptip>
          </div>
        </div>
      </div>
      <div class="integral-item" v-show="tabIndex == 0">
        <div>
          
          <!-- <img
            src="../../assets/images/v3/icon/select.svg"
            style="transform: rotate(-45deg)"
          /> -->
          <!-- sultan -->
          <span class="iconfont iconselect" style="transform:rotate(-45deg);right:46px;"></span>
          <p><span>+</span>{{ integralStatistics.IntegralToday }}</p>
          <div>今日获得积分</div>
        </div>
        <div>
          <!-- <img src="../../assets/images/v3/integral-03.png" /> -->
          <!-- sultan -->
          <span class="iconfont iconbrush"></span>
          <p>{{ integralStatistics.GetIntegralCount }}</p>
          <div>已签到次数</div>
        </div>
        <div>
          <!-- <img
            src="../../assets/images/v3/integral-02.png"
            style="transform: rotate(-45deg)"
          /> -->
          <!-- sultan -->
          <span class="iconfont iconselect" style="transform:rotate(-45deg);right:46px;"></span>
          <p><span>+</span>{{ integralStatistics.GetIntegral }}</p>
          <div>签到获得积分</div>
        </div>
        <div>
          <!-- <img src="../../assets/images/v3/integral-04.png" /> -->
          <!-- sultan -->
          <span class="iconfont iconservice"></span>
          <p><span>+</span>{{ integralStatistics.BuyIntegral }}</p>
          <div>购买获得积分</div>
        </div>
        <div>
          <!-- <img src="../../assets/images/v3/integral-05.png" /> -->
          <!-- sultan -->
          <span class="iconfont iconaddpeople"></span>
          <p><span>+</span>{{ integralStatistics.IntegralTypeCount }}</p>
          <div>邀请好友数</div>
        </div>
        <div>
          <!-- <img
            src="../../assets/images/v3/integral-02.png"
            style="transform: rotate(-45deg)"
          /> -->
          <!-- sultan -->
          <span class="iconfont iconselect" style="transform:rotate(-45deg);right:46px;"></span>
          <p><span>+</span>{{ integralStatistics.InviteIntegral }}</p>
          <div>邀请好友得积分</div>
        </div>
        <div>
          <!-- <img src="../../assets/images/v3/integral-06.png" /> -->
          <!-- sultan -->
          <span class="iconfont iconselect"></span>
          <p><span>+</span>{{ integralStatistics.SumShareIntegral }}</p>
          <div>好友消费得积分</div>
        </div>
        <div>
          <!-- <img
            src="../../assets/images/v3/integral-02.png"
            style="transform: rotate(-45deg)"
          /> -->
          <!-- sultan -->
          <span class="iconfont iconselect" style="transform:rotate(-45deg);right:46px;"></span>
          <p>{{ integralStatistics.SumUseIntegral }}</p>
          <div>已使用积分</div>
        </div>
      </div>
      <div class="main-header" v-show="tabIndex == 1"></div>
      <div class="main-table scroll-top" v-show="tabIndex == 1">
        <table>
          <thead>
            <tr>
              <th style="width: 180px">时间</th>
              <th style="width: 120px">
                <Select
                  v-model="integralType"
                  size="small"
                  style="width: 100px; margin-left: -10px"
                >
                  <Option
                    v-for="item in integralTypeList"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                  >
                </Select>
              </th>
              <th>说明</th>
              <th style="width: 160px">IP</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filterInteralList" :key="index">
              <td>{{ item.createTime }}</td>
              <td class="tac">{{ item.changeIntegral }}</td>
              <td>{{ item.content }}</td>
              <td>{{ item.ip }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="am-fr user-main">
      <div class="user-main-content" v-show="tabIndex == 1"></div>
    </div>
    <Modal
      v-model="signModel"
      :closable="false"
      :mask-closable="false"
      footer-hide
      class-name="vertical-center-modal"
    >
      <div style="text-align: center">
        <img
          src="../../assets/images/sign.png"
          alt="abc"
          style="margin: 0 auto"
        />
        <p style="margin: 20px auto; font-size: 18px">
          恭喜您获得
          <span style="color: #ff6a00; margin: 0 5px">{{ signIntegral }}</span>
          积分
        </p>
        <div style="width: 130px; margin: 0 auto">
          <Button type="primary" shape="circle" long @click="viewIntegral"
            >查看积分</Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { user, study } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      integralStatistics: {}, //积分统计
      tabIndex: 0, //tab切换
      integralList: [], //积分明细
      integralType: 0,
      integralTypeList: [
        {
          value: 0,
          label: "收入/支出",
        },
        {
          value: 1,
          label: "收入",
        },
        {
          value: 2,
          label: "支出",
        },
      ],
      signModel: false,
      signIntegral: 0,
    };
  },
  computed: {
    filterInteralList() {
      if (this.integralType == 1) {
        return this.integralList.filter((m) => m.changeIntegral > 0);
      } else if (this.integralType == 2) {
        return this.integralList.filter((m) => m.changeIntegral < 0);
      } else {
        return this.integralList;
      }
    },
  },
  mounted() {
    this.setMetaData("我的积分");
    this.getMyIntegral();
  },
  methods: {
    getMyIntegral: function () {
      user.getMyIntegral(this.loginUser.userId).then((res) => {
        //console.log("statistics", res);
        if (res.status == 1) {
          this.integralStatistics = res.data;
        }
      });
      user.getIntegralDetail(this.loginUser.userId).then((res) => {
        //console.log("list", res);
        if (res.status == 1) {
          this.integralList = res.data;
        }
      });
    },
    signIn() {
      user
        .signIn(this.siteConfig.agencyId, this.loginUser.userId)
        .then((res) => {
          //console.log('sign',res);
          if (res.status === 1) {
            this.signIntegral = res.data.changeIntegral;
            this.signModel = true;
          }
        });
    },
    viewIntegral() {
      this.signModel = false;
      this.getMyIntegral();
    },
    clickTab(index) {
      if (this.tabIndex == index) return false;
      this.tabIndex = index;
    },
  },
};
</script>


<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";
// sultan
@import "../../assets/css/iconfont.css";
.integral-total {
  position: relative;
  padding: 30px;
  height: 140px;
  display: flex;
  align-items: center;
  // border-bottom: 1px solid #e7e7e7;
  background: url("../../assets/images/v3/integral-bg.png") center;
  
  // .icon {
  //   width: 72px;
  //   height: 72px;
  // }

  // //sultan
  .iconfont {
    width: 72px;
    height: 72px;
    font-size: 72px;
    color: #41a1fc;
  }
  .integral {
    flex: 1;
    font-size: 16px;
    font-weight: bold;
  }
  .sign {
    width: 120px;
    text-align: center;
  }
  .tips {
    position: absolute;
    color: #999;
    right: 55px;
    top: 20px;
  }
}
.integral-item {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 15px;
  & > div {
    position: relative;
    width: 270px;
    height: 100px;
    background-color: #fff;
    box-shadow: 0 0px 5px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin: 15px 21px;
    padding-left: 20px;
    .iconfont {
      // sultan
      font-size: 72px;
      color: #41a1fc;
      opacity: 0.3;
      position: absolute;
      right: 30px;
      top: 0px;
      height: 72px;
      width: 72px;
    }
    // sultan
    // img {
    //   position: absolute;
    //   right: 30px;
    //   top: 15px;
    // }
    p {
      margin-top: 24px;
      text-align: left;
      line-height: 30px;
      font-size: 26px;
      color: #595959;
      font-weight: bold;
      span {
        font-size: 22px;
      }
    }
    div {
      line-height: 30px;
      color: #666;
    }
  }
}
</style>